import React, { useState } from "react";
import { DemoBannerContainer, DialogText } from "./style";
import { BlueOutlinedBtn, BlueWhiteBtn } from "common/button";
import CustomizedDialogs from "common/modal/component/modalBase";

const DemoModeBanner = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <DemoBannerContainer>
        <div className="banner-content">
          <div className="message">
            <div className="header">Demo Mode</div>
            <div>
              Data is reset regularly so do not store important information
              here.
            </div>
          </div>

          <BlueOutlinedBtn title="More Info" onClick={() => setOpen(true)} />
        </div>
      </DemoBannerContainer>
      <CustomizedDialogs
        open={open}
        handleClose={() => setOpen(false)}
        title="Demo Mode"
        divider={true}
        maxWidth="500px"
      >
        <DialogText>
          <div>
            <div>
              This is a space for you to test out how Paylab works. Browse some
              of the sample projects to see how you can set up contracts. Try
              out new features. Switch off demo mode in the menu of your
              profile.
            </div>
          </div>
          <div>
            <div>Note:</div>
            <div>
              Some features are unavailable in demo mode. Data is regularly
              reset so do not store important information here.
            </div>
          </div>
        </DialogText>
        <BlueWhiteBtn title="Ok" onClick={() => setOpen(false)} />
      </CustomizedDialogs>
    </>
  );
};

export default DemoModeBanner;
